import { hasPermission } from './permission'
import * as format from "@/utils/format"
import  moment  from "moment";
import store from '@/store'
import { imgPath } from '@/styles/var.scss'
const filters = Object.keys(format).filter(v=>v.startsWith('format'))
.reduce((a,key)=>{
  a[key.substring(6).toLowerCase()] = format[key]
  return a
},{})
export default {
  install(Vue) {
    Object.keys(filters).forEach(key => {
      Vue.prototype['$'+key] = filters[key]
      Vue.filter(key, filters[key])
    })

    const success = ({ message }) => uni.showToast({ title: message, icon: 'success', mask: true, duration: 3000 })
    const fail = (res) => uni.showToast({ title: typeof res === 'string' ? res : res.message, icon: 'none', duration: 3000 })
    //消息
    Vue.prototype.$handleError = function (e) {
      if (this && this.$refs && this.$refs['uTips']) {
        this.$refs['uTips'].show({ type: 'error', title: typeof e === 'string' ? e : e.message, duration: 3000 })
      } else {
        fail(e)
      }
    }
    Vue.prototype.$toast = fail
    Vue.prototype.$message = {
      success,
      warning: fail,
      error: fail,
    }
    Vue.prototype.$confirm = (confirmText, title, options) => new Promise((resolve, reject) => {
      uni.showModal({
        title: title,
        content: confirmText,
        success: function (res) {
          if (res.confirm) {
            resolve()
          } else if (res.cancel) {
            reject()
          }
        },
        ...options
      });
    })

    function hidePhoneNumber(phoneNumber) {
      return phoneNumber.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
    }
    Vue.prototype.$hidePhoneNumber = hidePhoneNumber

    function wartime(time1,time2) {
      if(moment(time1) > moment(time2)){
        return true
      }else{
        return false
      }
    }
    Vue.prototype.$wartime = wartime

    function imgUrl(path) {
      const _imgPath = imgPath.substring(1,imgPath.length-1)
      return `${_imgPath}/${path}`
    }
    Vue.prototype.$imgUrl = imgUrl
    Vue.prototype.$defaultImg = imgUrl('default.png')

    Vue.prototype.$navTo = function (path, query) {
      if(!path) return
      if (path.indexOf("mp://") != -1) {
        const appid = path.substring(5, path.indexOf("@"));
        const url = path.substring(path.indexOf("@") + 1, path.length);
        uni.navigateToMiniProgram({
          appId: appid,
          path: url
        });
      } else {
        this.$Router.push(path,query);
      }
    }
    Vue.prototype.callPhone = function (phoneNumber,confirm) {
      if(confirm===true){
        uni.showActionSheet({
          itemList: ['拨打电话'],
          success: (res)=> {
            this.callPhone(phoneNumber)
          },
        });
      }else{
        uni.makePhoneCall({
          phoneNumber
        })
      }
    }
    Vue.prototype.openLocation = function ({ lat, lng, name, address }={}) {
      if(!lat || !lng) return
      uni.openLocation({
        latitude: +lat,
        longitude: +lng,
        name, address,
        success: function () {
        },complete(e){
          console.log(e,'---e')
        }
      });
    }
    Vue.prototype.previewImg = function (urls,current) {
      uni.previewImage({current,urls})
    }
    Vue.prototype.cropImage = function (imgUrl,w,h,q = 90) {
      if(!imgUrl) return ''
      var process = ''
      if(!isNaN(w) && !isNaN(h)){
        //固定宽高，按长边缩放
        process = `image/auto-orient,1/resize,m_fill,w_${w},h_${h}/quality,q_${q}`
      }
      if(process){
        return imgUrl + '?x-oss-process='+ process
      }
      return imgUrl
    }
    Vue.prototype.hasPermission = hasPermission

    Vue.prototype.goHome = function(){
      this.$Router.replaceAll('/pages/index/index')
    }

    Vue.prototype.requestLoading = async function (fun,options={
      title:'正在加载...',mask:true
     }) {
      options && uni.showLoading(options)
      try{
        const res = await fun()
        return res
      }catch(e){
        this.$handleError(e)
        return Promise.reject(e)
      }finally{
        uni.hideLoading()
      }
    }

    Vue.prototype.toAppRoute= function(routeKey){
      console.log(store.state.app.config,'routeKey')
      this.$Router.push({
        path: store.state.app.config.app_routes[routeKey]
      })
    }
  }
}
